import { Component } from '@angular/core';
import { BreadcrumbComponent } from '../elements/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-dashboard',
  imports: [BreadcrumbComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: ''
  }
}
